exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer[data-v-67bd1ce6]{padding-top:10px;height:50px;font-size:12px;text-align:center;color:#666;border-top:1px solid #ddd}", ""]);

// exports
